import { postJson } from '../httpClient';

export const airtableAPI = {
  /**
   * Add a user to Airtable
   * @param {Object} params - User data
   * @param {string} params.firstName - User's first name
   * @param {string} params.lastName - User's last name
   * @param {string} params.email - User's email (required)
   * @param {string} [params.organization] - User's organization (optional)
   */
  addUser: (params) => postJson('/api/airtable/add-user', params),
};
